import { IRuleSet } from '../../../features/detail/interfaces/IRuleResults';
import {
  DecisionSortOrder,
  RateClassSortOrder,
} from '../../constants/decision';

const NO_DECISION_SORT_ORDER = 4;
const NO_RATE_CLASS_SORT_ORDER = 5;

export const sortRuleSets = (ruleSets: IRuleSet[]): IRuleSet[] => {
  return [...ruleSets]
    .map(ruleSet => ({
      ...ruleSet,
      matchedRules: [...ruleSet.matchedRules].sort((a, b) => {
        // Decision comparison
        const decisionCompare =
          (DecisionSortOrder[a.decision as keyof typeof DecisionSortOrder] ??
            NO_DECISION_SORT_ORDER) -
          (DecisionSortOrder[b.decision as keyof typeof DecisionSortOrder] ??
            NO_DECISION_SORT_ORDER);
        if (decisionCompare !== 0) return decisionCompare;

        // Rate class comparison
        if (!a.rateClass && !b.rateClass) return 0;
        if (!a.rateClass) return 1;
        if (!b.rateClass) return -1;

        const rateClassCompare =
          (RateClassSortOrder[a.rateClass as keyof typeof RateClassSortOrder] ??
            NO_RATE_CLASS_SORT_ORDER) -
          (RateClassSortOrder[b.rateClass as keyof typeof RateClassSortOrder] ??
            NO_RATE_CLASS_SORT_ORDER);
        if (rateClassCompare !== 0) return rateClassCompare;

        // Debits comparison
        return (b.debits ?? 0) - (a.debits ?? 0);
      }),
    }))
    .sort((a, b) => {
      if (!a.outcome?.decision && !b.outcome?.decision) return 0;
      if (!a.outcome?.decision) return 1;
      if (!b.outcome?.decision) return -1;

      const decisionCompare =
        (DecisionSortOrder[
          a.outcome.decision as keyof typeof DecisionSortOrder
        ] ?? NO_DECISION_SORT_ORDER) -
        (DecisionSortOrder[
          b.outcome.decision as keyof typeof DecisionSortOrder
        ] ?? NO_DECISION_SORT_ORDER);
      if (decisionCompare !== 0) return decisionCompare;

      if (!a.outcome?.rateClass && !b.outcome?.rateClass) return 0;
      if (!a.outcome?.rateClass) return 1;
      if (!b.outcome?.rateClass) return -1;

      const rateClassCompare =
        (RateClassSortOrder[
          a.outcome.rateClass as keyof typeof RateClassSortOrder
        ] ?? NO_RATE_CLASS_SORT_ORDER) -
        (RateClassSortOrder[
          b.outcome.rateClass as keyof typeof RateClassSortOrder
        ] ?? NO_RATE_CLASS_SORT_ORDER);
      if (rateClassCompare !== 0) return rateClassCompare;

      return (b.outcome?.debits ?? 0) - (a.outcome?.debits ?? 0);
    });
};
